import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import Header from './components/Header'
import Main from './containers/Main'
import GameList from './data/GameList'
import ActivityList from './data/ActivityList'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameList: GameList,   // really, this should be a copy of the GameList
      activityList: ActivityList.getActivityForPlayer(null), // ditto
    };
  }

  render() {
    return (
      <div>
        <Header />
        <Main activityList={this.state.activityList}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js